<div *ngIf="request" class="container">
  <p>Request By: <span>{{request.user.name}}</span></p>
  <p>Email: <span>{{request.user.email}}</span></p>
  <p>Request Type: <span>{{request.requestType | uppercase}}</span></p>
  <p>Type of Background: <span>{{request.type === 'photoBox' ? 'Photo Box' : 'Flat'}}</span></p>
  <div class="text-center" *ngIf="request.backgroundFloor">
    <hr>
    <p class="text-center" style="font-size: 1.5rem;">Floor</p>
    <img style="height: 90px;" [src]="request.backgroundFloor.file.path" alt="">
    <p>Floor name: {{request.backgroundFloor.name}}</p>
  </div>
  <div *ngIf="request.floorFile">
    <hr>
    <p class="text-center" style="font-size: 1.5rem;">Floor</p>
    <p>Floor file uploaded by client</p>
    <img style="height: 90px;" [src]="request.floorFile.path" alt="">
    <button class="custom-button d-block" (click)="downloadFile(request.floorFile)">Download</button>
  </div>
  <div *ngIf="request.floorDescription">
    <p>Floor Description: {{request.floorDescription}}</p>
  </div>
  <div class="text-center" *ngIf="request.backgroundWall">
    <hr>
    <p class="text-center" style="font-size: 1.5rem;">Wall</p>
    <img style="height: 90px;" [src]="request.backgroundWall.file.path" alt="">
    <p>Wall name: {{request.backgroundWall.name}}</p>
  </div>
  <div *ngIf="request.wallFile">
    <hr>
    <p class="text-center" style="font-size: 1.5rem;">Wall</p>
    <p>Wall file uploaded by client</p>
    <img style="height: 90px;" [src]="request.wallFile.path" alt="">
    <button class="custom-button d-block" (click)="downloadFile(request.wallFile)">Download</button>
  </div>
  <div *ngIf="request.wallDescription">
    <p>Wall Description: {{request.wallDescription}}</p>
  </div>
  <div class="text-center" *ngIf="request.backgroundOffer && request.requestType === 'ourChoice'">
    <hr>
    <p class="text-center" style="font-size: 1.5rem;">OUR CHOICE OFFER</p>
    <img style="height: 90px;" [src]="request.backgroundOffer.file.path" alt="">
    <p>Offer Name: {{request.backgroundOffer.name}}</p>
  </div>
  <hr>
  <div *ngIf="request.logoFile">
    <p class="text-center" style="font-size: 1.5rem;">Logo</p>
    <p>Logo Position: <span>{{request.logoPosition | titlecase}}</span></p>
    <p>Logo Type: <span>{{request.logoType | titlecase}}</span></p>
    <img style="height: 90px;" [src]="request.logoFile.path" alt="">
    <button class="custom-button d-block" (click)="downloadFile(request.logoFile)">Download</button>
  </div>
  <hr>
  <div *ngIf="request.slogan">
    <p>Slogan: <span>{{request.slogan}}</span></p>
    <p>Slogan File: <span>{{request.sloganFontFile.filename}}</span></p>
    <button class="custom-button d-block" (click)="downloadFile(request.sloganFontFile.path, true)">Download</button>
  </div>
  <hr>
  <div *ngIf="request.frameFile">
    <p>Frame</p>
    <img style="height: 90px;" [src]="request.frameFile.path" alt="">
    <button class="custom-button d-block" (click)="downloadFile(request.frameFile)">Download</button>
  </div>
</div>